import * as Sentry from '@sentry/react';

export function initSentry() {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      // Enable performance monitoring
      tracesSampleRate: 1.0, // Adjust this value in production (1.0 = 100% of transactions for performance monitoring)
      // Enable session replay
      replaysSessionSampleRate: 0.1, // 10% of sessions
      replaysOnErrorSampleRate: 1.0, // 100% of error sessions
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      profilesSampleRate: 1.0, // 100% of transactions are profiled
      // Configure beforeSend to filter or modify events
      beforeSend(event: Sentry.ErrorEvent) {
        // You can modify the event here before it's sent
        return event;
      },
      // Enable tracing
      integrations: [
        // Add browser tracing integration if needed
        // new Sentry.browserTracingIntegration(),
        // Add replay integration if needed
        // new Sentry.replayIntegration(),
      ],
    });
  }
}

export { Sentry };
